import {fadeIn, fadeOut} from "../helpers/animation";

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.js-header-mobile-burger')) {
		document.querySelector('.js-header-mobile-burger').addEventListener('click', (e) => {
			const header = document.querySelector('.header');
			const activeClass = '--header-mobile-opened';

			header.classList.toggle(activeClass);
			e.target.classList.toggle('header-mobile__burger--active');
			document.querySelector('body').classList.toggle('--scroll-disabled')

			if (header.classList.contains(activeClass)) {
				fadeIn(document.querySelector('.js-header-mobile-hidden'));
			} else {
				fadeOut(document.querySelector('.js-header-mobile-hidden'));
			}
		});
	}
});
